import type { IconName } from './Icon';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
  /**
   * Права, при которых раздел виден. Хотя бы одно подходящее — как у
   * admin_api_permission со списком через запятую на сервере. Без поля
   * раздел виден всем (дашборд, свой профиль).
   */
  permissions?: string[];
}

export interface NavGroup {
  title?: string;
  items: NavItem[];
}

/** Разделы левой навигации. Соответствуют разделам макета «Компас». */
export const NAV_GROUPS: NavGroup[] = [
  { items: [{ to: '/', label: 'Дашборд', icon: 'dashboard' }] },
  {
    title: 'Клиенты',
    items: [
      { to: '/clients', label: 'Все клиенты', icon: 'users', permissions: ['platform*.customers.list'] },
      { to: '/clients/new', label: 'Создать клиента', icon: 'plus', permissions: ['platform*.customers.add'] },
    ],
  },
  { title: 'Каталог', items: [{ to: '/tests', label: 'Тесты', icon: 'testChecklist', permissions: ['platform*.tarif'] }] },
  {
    title: 'Администрирование',
    items: [
      { to: '/admins', label: 'Администраторы', icon: 'shield', permissions: ['platform.systems.users'] },
      { to: '/portal-users', label: 'Пользователи ЛК', icon: 'user', permissions: ['platform*.customers.list'] },
      { to: '/roles', label: 'Роли', icon: 'lock', permissions: ['platform.systems.roles'] },
      { to: '/marketing', label: 'Маркетинг', icon: 'gift', permissions: ['platform.marketing', 'platform.ads'] },
      { to: '/data-operators', label: 'Операторы данных', icon: 'fileText', permissions: ['platform.operator'] },
    ],
  },
  {
    title: 'Аналитика',
    items: [
      { to: '/events', label: 'Журналы событий', icon: 'clock', permissions: ['platform*.events.list', 'platform.admin.events'] },
      { to: '/reports', label: 'Отчёты', icon: 'reports', permissions: ['platform*.reports.give'] },
      { to: '/support', label: 'Обращения в поддержку', icon: 'support', permissions: ['platform.support.list'] },
    ],
  },
  { title: 'Аккаунт', items: [{ to: '/profile', label: 'Настройки профиля', icon: 'settings' }] },
];

/**
 * Заголовок страницы по маршруту – источник для хлебных крошек в Topbar.
 * /login сюда не входит: это отдельный маршрут вне AppLayout, Topbar там нет.
 */
export const PAGE_TITLES: Record<string, string> = Object.fromEntries(
  NAV_GROUPS.flatMap((g) => g.items).map((i) => [i.to, i.label]),
);
